import { Get, getUrl, Post, Put } from '@/services/customer-support/index'

export const List = async body => {
  return Post(getUrl('cnps.css.order-contract.get-list'), body)
}
export const OderDetails = async body => {
  return Post(getUrl('cnps.css.order-contract.detail'), body)
}

export const OderHistory = async body => {
  return Post(getUrl('cnps.css.order-contract.history'), body)
}

export const OderDevice = async body => {
  return Post(getUrl('cnps.css.order-contract.list-device'), body)
}
